import * as React from "react";
import {Route} from "react-router-dom";
import LazyLoadingWrapper from "../../components/LazyLoadingWrapper/LazyLoadingWrapper";


const ReadmePage = React.lazy(() => import('./ProjectHomePageMode'));

export const useReadmeRoutes = () => {
    return (
        <Route path="project" element={<LazyLoadingWrapper element={<ReadmePage/>}/>}/>
    );
}